import { __decorate } from "tslib";
import { singleton } from 'mana-syringe';
import { isString } from '@antv/util';
import { GeometryAABBUpdater } from './interfaces';
import { Shape } from '../../types';

var RectUpdater =
/** @class */
function () {
  function RectUpdater() {}

  RectUpdater.prototype.update = function (parsedStyle, object) {
    var img = parsedStyle.img,
        _a = parsedStyle.x,
        x = _a === void 0 ? 0 : _a,
        _b = parsedStyle.y,
        y = _b === void 0 ? 0 : _b,
        width = parsedStyle.width,
        height = parsedStyle.height;
    var contentWidth = 0;
    var contentHeight = 0;
    var widthUnit = width.unit,
        widthValue = width.value;
    var heightUnit = height.unit,
        heightValue = height.value;

    if (widthUnit === '' || widthUnit === 'px') {
      contentWidth = widthValue;
    }

    if (heightUnit === '' || heightUnit === 'px') {
      contentHeight = heightValue;
    } // resize with HTMLImageElement's size


    if (img && !isString(img)) {
      if (!contentWidth) {
        contentWidth = img.width;
      }

      if (!contentHeight) {
        contentHeight = img.height;
      }
    }

    object.parsedStyle.widthInPixels = contentWidth;
    object.parsedStyle.heightInPixels = contentHeight;
    return {
      width: contentWidth,
      height: contentHeight,
      x: x,
      y: y
    };
  };

  RectUpdater = __decorate([singleton({
    token: [{
      token: GeometryAABBUpdater,
      named: Shape.RECT
    }, {
      token: GeometryAABBUpdater,
      named: Shape.IMAGE
    }, {
      token: GeometryAABBUpdater,
      named: Shape.GROUP
    }]
  })], RectUpdater);
  return RectUpdater;
}();

export { RectUpdater };